module.exports = __webpack_public_path__ + "static/media/group-chat-analyzer-image.9c31a11d.png";